import { call, put, takeLatest } from "redux-saga/effects";

import { PayloadAction } from "@reduxjs/toolkit";
import { message } from "antd";
import api from "service/apiService";
import { ApiResponse } from "types";
import { translate } from "utils";
import {
	getVouchersAsync,
	getVoucherDetailsAsync,
	GetVouchersAsyncPayload,
	GetVoucherDetailsPayload,
	setVouchers,
	setVoucher,
	updateVoucherAsync,
	UpdateVoucherPayload,
	getVoucherCodesAsync,
	setVoucherCodes,
	GetVoucherCodesAsyncPayload,
	CreateVoucherPayload,
	createVoucherAsync,
	SendToCustomerPayload,
	sendToCustomerAsync,
} from "./voucher.slice";
import { Voucher, VoucherCode } from "../types";

// Get list vouchers
function* getVouchersSaga(action: PayloadAction<GetVouchersAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			console.log("call api check");
			const { data: response } = await api.get<ApiResponse<Voucher[]>>(
				"/dashboard/vouchers",
				{ ...query, skip: query.skip },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setVouchers.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetVouchers() {
	yield takeLatest(getVouchersAsync, getVouchersSaga);
}

// Get voucher details
function* getVoucherDetailsSaga(
	action: PayloadAction<GetVoucherDetailsPayload>,
) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<Voucher>>(
				`/dashboard/vouchers/${id}`,
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		yield put({ type: setVoucher.type, payload: response });
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchVoucherDetails() {
	yield takeLatest(getVoucherDetailsAsync, getVoucherDetailsSaga);
}

// Create new voucher
function* createVoucherSaga(action: PayloadAction<CreateVoucherPayload>) {
	const { voucher, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post("/dashboard/vouchers", voucher);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchCreateVoucher() {
	yield takeLatest(createVoucherAsync, createVoucherSaga);
}

// Update voucher details
function* updateVoucherSaga(action: PayloadAction<UpdateVoucherPayload>) {
	const { id, status, rejectReason, callback } = action.payload;

	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.patch(`/dashboard/vouchers/${id}`, {
				status,
				...(rejectReason ? { rejectReason } : {}),
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		message.success(translate("Update successful"));
		callback?.(response.data);
	} else {
		message.error(translate(error.message));
	}
}

function* watchUpdateVoucher() {
	yield takeLatest(updateVoucherAsync, updateVoucherSaga);
}

// Get list voucher codes
function* getVoucherCodesSaga(
	action: PayloadAction<GetVoucherCodesAsyncPayload>,
) {
	const { id, query, callback, willNotUpdate } = action.payload;
	console.log("query", query);
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.get<ApiResponse<VoucherCode[]>>(
				"/dashboard/vouchers/code",
				{ ...query, skip: query.skip, voucher: id },
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		console.log("callback");
		callback?.(response.data);
		if (!willNotUpdate) {
			yield put({ type: setVoucherCodes.type, payload: response });
		}
	} else {
		message.error(translate(error.message));
	}
}

function* watchGetVoucherCodes() {
	yield takeLatest(getVoucherCodesAsync, getVoucherCodesSaga);
}

// Send voucher codes to customers
function* sendToCustomerSaga(action: PayloadAction<SendToCustomerPayload>) {
	const { id, users, callback, errorCallback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const { data: response } = await api.post(
				`/dashboard/vouchers/${id}/send`,
				{
					users,
				},
			);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.();
	} else {
		errorCallback?.();
		message.error(translate(error.code));
	}
}

function* watchSendToCustomer() {
	yield takeLatest(sendToCustomerAsync, sendToCustomerSaga);
}

const contactSupportSaga = [
	watchGetVouchers(),
	watchVoucherDetails(),
	watchCreateVoucher(),
	watchUpdateVoucher(),
	watchGetVoucherCodes(),
	watchSendToCustomer(),
];
export default contactSupportSaga;
